import { useContext } from 'react';

import { LoginContext } from '../LoginContext';

export default function useLoginContext() {
  const { activeMethod, onEmailLogin, onFacebookLogin, onGoogleLogin, status } = useContext(LoginContext);

  return {
    didFailEmailLogin: activeMethod === 'email' && status === 'error',
    didFailFacebookLogin: activeMethod === 'facebook' && status === 'error',
    didFailGoogleLogin: activeMethod === 'google' && status === 'error',
    isLoadingEmailLogin: activeMethod === 'email' && status === 'loading',
    isLoadingFacebookLogin: activeMethod === 'facebook' && status === 'loading',
    isLoadingGoogleLogin: activeMethod === 'google' && status === 'loading',
    onEmailLogin,
    onFacebookLogin,
    onGoogleLogin,
  };
}
